// src/StaticBackToTop.js

import React, { memo, useCallback } from 'react';
import { useTheme } from './ThemeContext';
import './StaticBackToTop.css';

// ── QR grid — CSS ─────────────────────────────────────────────────────────────
const QrGridBackground = memo(() => (
  <div aria-hidden="true" className="btt-grid">
    <div className="btt-grid__inner">
      {Array.from({ length: 32 }).map((_, i) => (
        <div key={i} className="btt-grid__cell"
          style={{ animation: `qrCellPulse ${3 + (i % 4)}s ease-in-out ${(i * 0.08) % 3}s infinite` }} />
      ))}
    </div>
  </div>
));
QrGridBackground.displayName = 'QrGridBackground';

// ── Particles — CSS ───────────────────────────────────────────────────────────
const PARTICLES = [
  { width: 7,  height: 7,  top: '15%', left: '8%',  duration: 4,   delay: 0   },
  { width: 8,  height: 8,  top: '70%', left: '92%', duration: 6,   delay: 1.5 },
];

const ParticlesLayer = memo(() => (
  <div aria-hidden="true" className="btt-particles">
    {PARTICLES.map((p, i) => (
      <div key={i} className="btt-particle"
        style={{ width: p.width, height: p.height, top: p.top, left: p.left,
          animation: `particleFloat ${p.duration}s ease-in-out ${p.delay}s infinite` }} />
    ))}
  </div>
));
ParticlesLayer.displayName = 'ParticlesLayer';

// ── Main component ────────────────────────────────────────────────────────────
const StaticBackToTop = memo(() => {
  const { isDark } = useTheme();

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className={"btt-section " + (isDark ? "btt-section--dark" : "btt-section--light")}>
      <QrGridBackground />
      <ParticlesLayer />
      <div aria-hidden="true" className="btt-orb" />

      <div className="btt-btn-wrap">
        <button
          className="btt-btn"
          onClick={scrollToTop}
          aria-label="Back to top"
          title="Back to top"
          type="button"
        >
          <svg className="btt-btn__icon" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
            <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
          </svg>
        </button>
      </div>
    </div>
  );
});

StaticBackToTop.displayName = 'StaticBackToTop';
export default StaticBackToTop;